/* @ngInject */
function CampaignEditController ($scope, $rootScope, $location, $stateParams, $q, $state, $translate, CampaignService, ConfirmationModalService, ToastService, UdsModalService, SegmentService, CampaignActionService, $timeout) {
  const getModulesPricingDialogController = () => import('../../../core/dialogs/modules-pricing/modules-pricing-dialog.controller')
  const getCampaignAccessDialogController = () => import('../../dialogs/campaign-access/campaign-access-dialog.controller')
  const getCampaignUpdateDialogController = () => import('../../dialogs/campaign-update/campaign-update-dialog.controller')

  $scope.campaign = {}
  $scope.activeTab = 'tab-1'
  $scope.flags = {
    publishActionsBtnDisabled: false,
    updateCampaignBtnDisabled: false
  }
  $scope.companyFeatures = {
    workflow: {
      access: false
    },
    posts: {
      access: false
    },
    audit: {
      access: false
    },
    documents: {
      access: false
    },
    dashboard: {
      access: false
    }
  }

  $scope.visitedTabs = {
    'tab-1': false,
    'tab-2': false,
    'tab-3': false,
    'tab-4': false,
    'tab-5': false,
    'tab-6': false,
    'tab-7': false,
    'tab-8': false
  }

  const api = {
    getCampaign,
    getModulesPricingDialogController,
    getCampaignAccessDialogController,
    getCampaignUpdateDialogController
  }

  this.getApi = () => api

  function activate () {
    $q.all([
      $rootScope.getCompanyFeaturesAndAddons(),
      $rootScope.getCompanyFeatures()
    ])
      .then(([companyFeaturesAndAddons, companyFeatures]) => {
        $scope.features = companyFeaturesAndAddons.features
        $scope.pricingPackageId = companyFeaturesAndAddons.pricingPackageId

        const hasWorkflow = $scope.features['WORKFLOW.ACCESS']
        const hasPosts = $scope.features['POSTS.ACCESS']
        const hasChecklist = $scope.features['CHECKLIST.ACCESS']
        const hasDashboard = companyFeatures.includes('CAMPAIGN_DASHBOARD')

        $scope.companyFeatures.workflow.access = hasWorkflow
        $scope.companyFeatures.posts.access = hasPosts
        $scope.companyFeatures.audit.access = hasChecklist
        $scope.companyFeatures.dashboard.access = hasDashboard
      })

    $rootScope.getCompanyFeatures().then((features) => {
      const hasDocuments = features.includes('DOCUMENTS_MODULE')
      $scope.companyFeatures.documents.access = hasDocuments
    })

    api.getCampaign($stateParams.id)

    if ($stateParams.activeTab) {
      $scope.activeTab = $stateParams.activeTab
      $scope.visitedTabs[$scope.activeTab] = true
    }
  }

  activate()

  function getCampaign (campaignId) {
    CampaignService.getCampaign(campaignId)
      .then((data) => {
        $timeout(() => {
          $scope.campaign = data
          $scope.flags.updateCampaignBtnDisabled = data.status === 'FINISHED' || data.isArchived
        }, 100)
      })
      .catch(() => {
        ToastService.defaultErrorToast()
      })
  }

  const deregisterActionsChanged = $rootScope.$on('campaign.actions-changed', function (event, actions) {
    if ($scope.campaign.status === 'IN_PROGRESS') {
      $scope.flags.publishActionsBtnDisabled = !actions || actions.length === 0
    }
  })

  const deregisterPostUpdated = $scope.$on('postUpdated', function () {
    api.getCampaign($stateParams.id)
  })

  $scope.goBack = function () {
    $state.go('campaigns', {}, { reload: true })
  }

  $scope.archiveCampaign = function () {
    ConfirmationModalService.createModal({
      title: $translate.instant('campaignEdit.archiveConfirm.title'),
      description: $translate.instant('campaignEdit.archiveConfirm.description'),
      buttonCancelText: $translate.instant('campaignEdit.archiveConfirm.cancel'),
      buttonConfirmText: $translate.instant('campaignEdit.archiveConfirm.confirm'),
      onConfirm: () => {
        CampaignService.archiveCampaign($scope.campaign.id)
          .then(() => {
            ToastService.showSuccessToast($translate.instant('campaignEdit.archiveConfirm.successMessage'))
            api.getCampaign($stateParams.id)
          })
          .catch(() => {
            ToastService.defaultErrorToast()
          })
      }
    })
  }

  $scope.unarchiveCampaign = function () {
    ConfirmationModalService.createModal({
      title: $translate.instant('campaignEdit.unarchiveConfirm.title'),
      description: $translate.instant('campaignEdit.unarchiveConfirm.description'),
      buttonCancelText: $translate.instant('campaignEdit.unarchiveConfirm.cancel'),
      buttonConfirmText: $translate.instant('campaignEdit.unarchiveConfirm.confirm'),
      onConfirm: () => {
        CampaignService.unarchiveCampaign($scope.campaign.id)
          .then(() => {
            ToastService.showSuccessToast($translate.instant('campaignEdit.unarchiveConfirm.successMessage'))
            api.getCampaign($stateParams.id)
          })
          .catch(() => {
            ToastService.defaultErrorToast()
          })
      }
    })
  }

  $scope.openModulesPricingDialog = function (sendEvent, feature) {
    const showPricingDialog = !$scope.companyFeatures[feature].access

    if (showPricingDialog) {
      api.getModulesPricingDialogController().then(({ ModulesPricingDialogController }) => {
        const modal = UdsModalService.createModal({
          controller: ModulesPricingDialogController,
          modalName: 'modulesPricingDialog',
          data: {
            module: { icon: feature }
          }
        })
        modal.open()
      })

      if (sendEvent) {
        SegmentService.track('pricing-plansfriction-menubanner-click')
      }
    }
  }

  $scope.openCampaignAccessDialog = (campaign) => {
    api.getCampaignAccessDialogController().then(({ CampaignAccessDialogController }) => {
      const campaignAccessDialog = UdsModalService.createModal({
        controller: CampaignAccessDialogController,
        modalName: 'campaignAccessDialog',
        data: {
          campaign
        }
      })

      campaignAccessDialog.open()
    })
  }

  $scope.openCampaignUpdateDialog = (campaign) => {
    api.getCampaignUpdateDialogController().then(({ CampaignUpdateDialogController }) => {
      const campaignUpdateDialog = UdsModalService.createModal({
        controller: CampaignUpdateDialogController,
        modalName: 'campaignUpdateDialog',
        data: { campaign },
        onClose: (updatedCampaign) => {
          if (!updatedCampaign) return
          $scope.$applyAsync(() => {
            $scope.campaign = {
              ...$scope.campaign,
              title: updatedCampaign.title,
              startDate: updatedCampaign.startDate,
              deliveryDate: updatedCampaign.deliveryDate,
              expireCampaignContentsOnFinish: updatedCampaign.expireCampaignContentsOnFinish
            }
            if ($scope.campaign.info) {
              $scope.campaign.info = {
                ...$scope.campaign.info,
                title: updatedCampaign.title,
                startDate: updatedCampaign.startDate,
                deliveryDate: updatedCampaign.deliveryDate,
                expireCampaignContentsOnFinish: updatedCampaign.expireCampaignContentsOnFinish
              }
            }
          })
        }
      })

      campaignUpdateDialog.open()
    })
  }

  const deregisterChangeTabMaterialAction = $rootScope.$on('campaign.change-tab-action', (event, tab) => {
    $scope.activeTab = tab
    $scope.visitedTabs[tab] = true
    $location.search('activeTab', tab)
  })

  $scope.$on('$destroy', () => {
    deregisterChangeTabMaterialAction()
    deregisterPostUpdated()
    deregisterActionsChanged()
  })

  $scope.handleTabChange = (event) => {
    const selected = event?.detail?.selected
    if (selected) {
      $scope.activeTab = selected
      $scope.visitedTabs[$scope.activeTab] = true
      $location.search('activeTab', $scope.activeTab)
    }
  }
}

export { CampaignEditController }
